import { render, staticRenderFns } from "./enrollment-report-table.vue?vue&type=template&id=8ba58350&scoped=true"
import script from "./enrollment-report-table.vue?vue&type=script&lang=js"
export * from "./enrollment-report-table.vue?vue&type=script&lang=js"
import style0 from "./enrollment-report-table.vue?vue&type=style&index=0&id=8ba58350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba58350",
  null
  
)

export default component.exports